import React, { Fragment } from 'react';
import sad from '../../../assets/images/other-images/sad.png';
import { useNavigate } from 'react-router-dom';
import { Container, Button, Media, Col } from "reactstrap";
import { H2, P } from '../../../AbstractElements';
import { useAuth } from '../../../_helper/Auth/AuthProvider';

const Error401 = ({ resetErrorBoundary = () => {} }) => {
    const { userData } = useAuth();
    const navigate = useNavigate();

    const handleBackToHome = () => {
        resetErrorBoundary(); // Reset the error boundary state
        if (!userData) {
            navigate('/auth/login');
        } else if (userData.role === 'admin') {
            navigate('/dashboard');
        } else if (userData.role === 'user') {
            navigate('/app/home');
        } else {
            navigate('/');
        }
    };

    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="error-wrapper">
                    <Container>
                        <Media body className="img-100" src={sad} alt="" />
                        <div className="error-heading">
                            <H2 attrH2={{ className: "headline font-warning" }}>{"401"}</H2>
                        </div>
                        <Col md="8 offset-md-2">
                            <P attrPara={{ className: "sub-content" }}>{"La page que vous essayez d'atteindre n'est actuellement pas disponible. Cela peut être dû au fait que la page n'existe pas ou a été déplacée."}</P>
                        </Col>
                        <div className="text-center mt-3">
                            <Button color="warning-gradien" size='lg' onClick={handleBackToHome}>
                                RETOUR À LA PAGE D'ACCUEIL
                            </Button>
                        </div>
                    </Container>
                </div>
            </div>
        </Fragment>
    );
};

export default Error401;